module.exports = __webpack_public_path__ + "img/red_026.ed83a44e.png";